import { render, staticRenderFns } from "./PazienteTeleconsultoHasssito.vue?vue&type=template&id=358ec70e&scoped=true"
import script from "./PazienteTeleconsultoHasssito.vue?vue&type=script&lang=js"
export * from "./PazienteTeleconsultoHasssito.vue?vue&type=script&lang=js"
import style0 from "./PazienteTeleconsultoHasssito.vue?vue&type=style&index=0&id=358ec70e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "358ec70e",
  null
  
)

export default component.exports